import React from "react";
import "./Footer.css";
export const Footer = () => {
  return (
    <footer id="footer">
      <div className="footer" style={{ backgroundColor: "blue", color: "white" }}>
        <span>© Hired All rights reserved.</span>
      </div>
    </footer>
  );
};
